import { render } from "./MenuVigna.vue?vue&type=template&id=603ef3b7"
import script from "./MenuVigna.vue?vue&type=script&lang=js"
export * from "./MenuVigna.vue?vue&type=script&lang=js"

import "./MenuVigna.vue?vue&type=style&index=0&id=603ef3b7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__